export default {
  nextVersion: "Next Version",
  previousVersion: "Previous Version",
  selectVersion: "Select Version",
  download: "Download document",
  deleteDocument: "Delete Document"
};
